import { InPageEditableField } from "components/MainSectionTemplate/InPageEditableField";
import { InPageEditableSectionField } from "components/MainSectionTemplate/types";
import React from "react";

interface Props {
  gridArea: string
  field: InPageEditableSectionField
}

export const PassengerCardField = (props: Props) => {
  const { gridArea, field } = props;

  return <div className="flex-column" style={{ gridArea: gridArea }}>
    {field.label && <div className="s1_small s1_gray">{field.label}</div>}
    <InPageEditableField
      compact
      darkerHover
      variant="sidePanel"
      field={field}
    />
  </div>
}

interface PassengerCardFieldNewProps {
  label: string
  gridArea: string
  render: () => React.ReactNode
}

export const PassengerCardFieldNew = (props: PassengerCardFieldNewProps) => {
  const { label, gridArea, render } = props;

  return <div className="flex-column" style={{ gridArea: gridArea }}>
    {label && <div className="s1_small s1_gray">{label}</div>}
    {render()}
  </div>
}